import { useState, useEffect } from "react";
import MyTable from "../../Components/MyTable";
import Mytitle from "../../Components/Mytitle";
import ModalForm from "../../Components/ModalForm";
import MyInput from "../../Components/Myinput";
import API from "../../Api/axiosConfig";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash, faEye } from "@fortawesome/free-solid-svg-icons";
import Can from "../../Components/Can";

function EmployeeWithdraws() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    employee_id: "",
    value: "",
    cash_type: "cash",
    description: "",
    date: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [editId, setEditId] = useState(null);

  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const [employees, setEmployees] = useState([]);
  const [showDetailsModal, setShowDetailsModal] = useState(false);

  const [selectedCustomer, setSelectedCustomer] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const { data } = await API.get("employees");
        setEmployees(data.data || data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchCategories();
  }, []);

  const handleAdd = () => {
    setFormData({
      employee_id: "",
      value: "",
      description: "",
      date: "",
      cash_type: "cash",
    });
    setEditId(null);
    setErrors({});
    setShowModal(true);
  };

  const handleEdit = (record) => {
    setFormData({
      employee_id: record.employee_id,
      value: record.value,
      description: record.description,
      date: record.date,
      cash_type: "cash",
    });
    setEditId(record.uuid);
    setErrors({});
    setShowModal(true);
  };

  const handleDeleteClick = (uuid) => {
    setDeleteId(uuid);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    setDeleting(true);
    try {
      await API.delete(`/services/${deleteId}`);
      console.log("تم حذف الخدمة بنجاح");
      setRefreshKey((prev) => prev + 1);
      setShowDeleteModal(false);
      setDeleteId(null);
    } catch (err) {
      console.error(err);
      toast.error("فشل الحذف");
    } finally {
      setDeleting(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    try {
      if (editId) {
        await API.put(`/employee-withdrowal/${editId}`, formData);
        console.log("تم تعديل السحب بنجاح");
      } else {
        await API.post("/employee-withdrowal", formData);
        console.log("تم إضافة السحب بنجاح");
      }
      setShowModal(false);
      setRefreshKey((prev) => prev + 1);
    } catch (err) {
      if (err.response?.data?.errors) {
        setErrors(err.response.data.errors);
      }
    } finally {
      setLoading(false);
    }
  };
  const handleShowDetails = (customer) => {
    setSelectedCustomer(customer);
    setShowDetailsModal(true);
  };

  const columns = [
    { header: "اسم الموظف", accessor: "employee.name" },
    { header: "رقم الهوية", accessor: "employee.national_id" },
    { header: "القيمة", accessor: "value" },
    { header: "الوصف", accessor: "description" },
    { header: "التاريخ", accessor: "date" },

    {
      header: "الإجراءات",
      accessor: (row) => (
        <>
          <Can permission="customer_show">
            <button
              className="btn btn-sm mx-1 extrabtn"
              onClick={() => handleShowDetails(row)}
              title="عرض التفاصيل">
              <FontAwesomeIcon icon={faEye} color="white" />
            </button>
          </Can>
          <Can permission="service_update">
            <button
              className="btn btn-sm btn-primary mx-1 no-style"
              onClick={() => handleEdit(row)}>
              <FontAwesomeIcon icon={faPen} />
            </button>
          </Can>
          <Can permission="service_update">
            <button
              className="btn btn-sm btn-danger no-style"
              onClick={() => handleDeleteClick(row.uuid)}>
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </Can>
        </>
      ),
      hideOnPrint: true,
    },
  ];

  return (
    <div className="container mt-5">
      <Mytitle title="مسحوبات الموظفين" />
      {/* <Can permission="service_create">

                <MyButton
                    text="إضافة خدمة"
                    variant="success"
                    type="button"
                    className="mb-3"
                    onClick={handleAdd}
                />
            </Can> */}

      <ModalForm
        show={showModal}
        onClose={() => setShowModal(false)}
        title={editId ? "تعديل السحب" : "إضافة سحب"}
        onSubmit={handleSubmit}
        loading={loading}
        mode="form">
        <MyInput
          as="select"
          value={formData.employee_id}
          onChange={(e) =>
            setFormData({ ...formData, employee_id: e.target.value })
          }
          options={[
            { value: "", label: "اختر الموظف" },
            ...employees.map((c) => ({
              value: c.id,
              label: c.name,
            })),
          ]}
          error={errors.category_id?.[0]}
        />
        <MyInput
          as="select"
          value={formData.cash_type}
          onChange={(e) =>
            setFormData({ ...formData, cash_type: e.target.value })
          }
          options={[{ value: "cash", label: "كاش" }]}
          error={errors.category_id?.[0]}
          disabled={true}
        />
        <MyInput
          label="القيمة"
          type="number"
          value={formData.value}
          onChange={(e) => setFormData({ ...formData, value: e.target.value })}
          error={errors.value?.[0]}
        />

        <MyInput
          label="الوصف"
          value={formData.description}
          onChange={(e) =>
            setFormData({ ...formData, description: e.target.value })
          }
          error={errors.description?.[0]}
        />
      </ModalForm>

      <ModalForm
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        title="تأكيد الحذف"
        onSubmit={confirmDelete}
        loading={deleting}
        mode="confirm"
        confirmText="حذف"
        cancelText="إلغاء">
        هل أنت متأكد أنك تريد حذف هذا الموظف؟
      </ModalForm>
      {/* <ModalForm
        show={showDetailsModal}
        onClose={() => setShowDetailsModal(false)}
        title={`${selectedCustomer?.name || ""}`}
        mode="view">
        {selectedCustomer?.balances?.length ? (
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>التاريخ</th>
                <th>النوع</th>
                <th>القيمة</th>
                <th>الرصيد</th>
              </tr>
            </thead>
            <tbody>
              {selectedCustomer.balances.map((b) => (
                <tr key={b.id}>
                  <td>{b.date}</td>
                  <td>
                    {b.type === "opening_balance"
                      ? "الرصيد الأفتتاحي"
                      : "receive_money_invoice"
                      ? "فاتورة"
                      : ""}
                  </td>
                  <td>{b.value}</td>
                  <td>{b.total_value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>لا توجد مدفوعات مسجلة لهذا العميل.</p>
        )}
      </ModalForm> */}
      <ModalForm
        show={showDetailsModal}
        onClose={() => setShowDetailsModal(false)}
        title={`تفاصيل السحب`}
        mode="print">
        {selectedCustomer ? (
          <>
            <div className="withdrawal-details print-area">
              {/* <div className="details-header text-center mb-4"> */}
              {/* <h3 className="title">بيان سحب نقدي</h3> */}
              {/* <p className="date">التاريخ: {selectedCustomer.date}</p> */}
              {/* </div> */}

              <div className="details-body">
                <div className="row mb-3 text-end">
                  <div className="col-6">
                    <div className="detail-item">
                      <span className="label fw-medium">رقم الهاتف: </span>
                      <span className="value">
                        {selectedCustomer.employee?.phone}
                      </span>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="detail-item">
                      <span className="label fw-medium">اسم الموظف: </span>
                      <span className="value">
                        {selectedCustomer.employee?.name}
                      </span>
                    </div>
                  </div>
                  <div className="col-6 text-end mt-2">
                    <div className="detail-item">
                      <span className="label fw-medium">رقم الهوية: </span>
                      <span className="value">
                        {selectedCustomer.employee?.national_id}
                      </span>
                    </div>
                  </div>
                  <div className="col-6 mt-2">
                    <div className="detail-item">
                      <span className="label fw-medium">النوع: </span>
                      <span className="value">
                        {selectedCustomer.cash_type === "cash"
                          ? "نقدي"
                          : selectedCustomer.cash_type === "bank"
                          ? "تحويل بنكي"
                          : "-"}
                      </span>
                    </div>
                  </div>
                  <div className="col-6 mt-2">
                    <div className="detail-item">
                      <span className="label fw-medium">القيمة: </span>
                      <span className="value">{selectedCustomer.value}</span>
                    </div>
                  </div>
                  <div className="col-6 mt-2">
                    <div className="detail-item">
                      <span className="label fw-medium">الوصف: </span>
                      <span className="value">
                        {selectedCustomer.description || "لا يوجد وصف"}
                      </span>
                    </div>
                  </div>
                  <div className="col-6 mt-2">
                    <div className="detail-item">
                      <span className="label fw-medium">تاريخ الحدث: </span>
                      <span className="value">
                        {new Date(selectedCustomer.created_at).toLocaleString(
                          "ar-EG",
                          {
                            dateStyle: "short",
                            timeStyle: "short",
                          }
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="col-6 mt-2">
                    <div className="detail-item"></div>
                  </div>
                </div>
              </div>

              {/* <div className="details-footer text-center mt-2 pt-2">
                <small className="text-muted">
                  التاريخ :{" "}
                  {new Date(selectedCustomer.created_at).toLocaleString(
                    "ar-EG"
                  )}
                </small>
              </div> */}
            </div>
          </>
        ) : (
          // <table className="table table-bordered">
          //   <thead>
          //     <tr>
          //       <th>التاريخ</th>
          //       <th>الموظف</th>
          //       <th>رقم الهاتف</th>
          //       <th>النوع</th>
          //       <th>القيمة</th>
          //       <th>الوصف</th>
          //     </tr>
          //   </thead>
          //   <tbody>
          //     <tr>
          //       <td>{selectedCustomer.date}</td>
          //       <td>{selectedCustomer.employee?.name}</td>
          //       <td>{selectedCustomer.employee?.phone}</td>
          //       <td>
          //         {selectedCustomer.cash_type === "cash"
          //           ? "نقدي"
          //           : selectedCustomer.cash_type === "bank"
          //           ? "تحويل بنكي"
          //           : "-"}
          //       </td>
          //       <td>{selectedCustomer.value}</td>
          //       <td>{selectedCustomer.description || "-"}</td>
          //     </tr>
          //   </tbody>
          // </table>
          <p>لا توجد بيانات متاحة.</p>
        )}
      </ModalForm>

      <MyTable
        resource="employee-withdrowal"
        columns={columns}
        refreshKey={refreshKey}
        title={"مسحوبات الموظفين"}
        button={{
          text: "إضافة سحب",
          onClick: handleAdd,
          variant: "success",
          permission: "service_create",
        }}
        filters={[
          {
            type: "text",
            name: "employee.national_id",
            label: "رقم الهويه",
          },
          {
            type: "text",
            name: "employee.name",
            label: "بحث الموظف",
          },
        ]}
      />
    </div>
  );
}

export default EmployeeWithdraws;
